import { TableCard } from '../../../../components'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { ListViewProvider } from './core/ListViewProvider'
import { ListFiltersProvider } from './core/ListFiltersProvider'
import { AvaliacoesPendentesListHeader } from './components/header/AvaliacoesPendentesListHeader'
import { AvaliacoesPendentesTable } from './table/AvaliacoesPendentesTable'

const AvaliacoesPendentesList = () => {
  return (
    <TableCard>
      <AvaliacoesPendentesListHeader />
      <AvaliacoesPendentesTable />
    </TableCard>
  )
}

export const AvaliacoesPendentesListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <ListFiltersProvider>
          <AvaliacoesPendentesList />
        </ListFiltersProvider>
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)
